module.exports = __webpack_public_path__ + "static/img/right-bottom-row-4.0e711e4d.png";